<template>
  <v-container class="my-custom-table">
    <v-simple-table v-if="!loading && stats.length">
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="(title,index) in headers"
              :key="index"
            >
              {{ title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in stats"
            :key="item.name"
            :style="{color:item.color}"
            class="table-row"
          >
            <td>{{ item.component }}</td>
            <td>{{ item.analysisName }}</td>
            <td>{{ item.average | toFixed(2) }}</td>
            <td>{{ item.min }}</td>
            <td>{{ item.max }}</td>
            <td>{{ item.stdev | toFixed(2) }}</td>
            <td>{{ item.analysisNumbers }}</td>
            <td>{{ item.days }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-container>
</template>

<script>
import * as d3 from 'd3';
import createColorScale from '@/components/graphics/colorScale';

export default {
    name: 'Statistics',
    components: {
    },
    props: {
        series: {
            type: Array,
            default: null,
        },
        seriesData: {
            type: Array,
            default: null,
        },
        colorScale: {
            type: Function,
            default: createColorScale,
        },
    },
    data() {
        return {
            stats: [],
            graphic: {},
            loading: false,
        };
    },
    computed: {
        headers() {
            return [
                this.$t('forms.labels.component'),
                this.$t('forms.labels.analysisName'),
                this.$t('forms.labels.average'),
                'Min',
                'Max',
                'STD dev',
                  `#${this.$t('forms.labels.analysis')}`,
                  `#${this.$t('forms.labels.days')}`,

            ];
        },
    },
    watch: {
        seriesData: {
            async handler() {
                this.stats = [];
                this.initStats();
            },
            deep: true,
        },
        series: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.initStats();
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.initStats();
    },
    methods: {
        initStats() {
            this.stats = [];
            if (!this.seriesData || this.seriesData.length === 0) return;
            this.seriesData.forEach((data, i) => {
                if (data.data.length === 0) return;
                const values = data.data.map(d => d.value);
                const max = d3.max(values);
                const min = d3.min(values);
                const average = d3.mean(values);
                const stdev = d3.deviation(values);
                const analysisNumbers = values.length;
                const days = d3.timeDay.count(d3.timeDay(new Date(data.data[0].date)),
                    d3.timeDay(new Date(data.data[data.data.length - 1].date))) + 1;
                const relatedSeries = this?.series.find(s => s?.seriesInfo?.id === data.id);
                const { seriesInfo } = relatedSeries;
                if (!seriesInfo) return;
                this.stats.push({
                    component: seriesInfo?.componentName || data?.componentName || '',
                    analysisName: seriesInfo?.analysisName || data?.name || '',
                    average,
                    min,
                    max,
                    stdev: stdev || 0,
                    analysisNumbers,
                    days,
                    color: this.colorScale(i),
                });
            });
        },
    },
};
</script>
<style scoped>


thead {
  margin: 0;
  padding: 0;
  border-bottom: 1px solid black !important;
  border-radius: 50px;
}

th {
  margin: 0;
  padding: 8px;
  border-bottom: 1px solid black !important;
  background-color: #f5f5f5;
  border-top: none;
}
td, th {
    border-left:solid black 1px;
}

.my-custom-table .v-data-table__wrapper table tr td {
  border-left: 1px solid rgb(0, 0, 0) !important;
  border-top: 1px solid rgb(0, 0, 0) !important;
}
.my-custom-table .v-data-table__wrapper table th:first-child,
.my-custom-table .v-data-table__wrapper table td:first-child {
    border-left: none !important;
}
.v-data-table{
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid black;
  border-radius: 5px;
  overflow: hidden;
  font-weight: 600;
}
</style>
